import { Component } from '@angular/core';
import { ThemeService } from './services/theme.service';
import { FirebaseAnalyticsService } from './services/firebase-analytics.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { environment } from './environments/environment';
import packageJson from '../../package.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  protected currentUrl = '';
  protected readonly inBeta = environment.inBeta;
  protected readonly version = packageJson.version;

  constructor(
    private themeService: ThemeService,
    private router: Router,
    private firebaseAnalyticsService: FirebaseAnalyticsService,
  ) {
    this.currentUrl = this.router.url;
    this.themeService.initialize(); // Initialize theme on app load
    this.firebaseAnalyticsService.init();
    this.initScreenTracking();
  }
  title = 'kekeno-questionnaire';

  private initScreenTracking(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe((event: NavigationEnd) => {
        const screenName = event.urlAfterRedirects;
        this.currentUrl = screenName;

        this.firebaseAnalyticsService.logEvent('screen_view', {
          firebase_screen: screenName,
          firebase_screen_class: screenName, // you can customize this if you want
        });
      });
  }

  protected showAppFooter(): boolean {
    const path = this.currentUrl.split('?')[0].split('#')[0];

    return ![
      '/details',
      '/welcome',
      '/questions',
      '/completed',
      '/take-questionnaire',
      '/questionnaire-unavailable',
    ].some(
      (hiddenPath) => path === hiddenPath || path.startsWith(`${hiddenPath}/`),
    );
  }
}
